class SealClubGiftForm extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.giftVariantIds = this.getGiftVariantIds();

    const signal = this.abortController.signal;
    document.addEventListener('variant:update', this.handleVariantUpdate, { signal });
    this.closest('form')?.addEventListener('change', this.handleFormChange, { signal });

    this.updateFromForm();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  getGiftVariantIds() {
    const data = this.querySelector('[data-gift-variant-ids]')?.textContent;

    try {
      return new Set(JSON.parse(data || '[]').map(String));
    } catch (error) {
      console.error('Unable to read Seal gift variant IDs.', error);
      return new Set();
    }
  }

  handleVariantUpdate = (event) => {
    const eventProductId = event.detail?.data?.productId;
    if (eventProductId && String(eventProductId) !== this.dataset.productId) return;

    this.setGiftState(event.detail?.resource?.id);
  };

  handleFormChange = () => {
    requestAnimationFrame(() => this.updateFromForm());
  };

  updateFromForm() {
    const variantInput = this.closest('form')?.querySelector('input[name="id"]');
    this.setGiftState(variantInput?.value);
  }

  setGiftState(variantId) {
    const isGift = this.giftVariantIds.has(String(variantId || ''));
    this.hidden = !isGift;

    this.querySelectorAll('[data-gift-property]').forEach((field) => {
      field.disabled = !isGift;

      if (!isGift && field.type !== 'hidden') {
        field.value = '';
      }
    });
  }
}

if (!customElements.get('seal-club-gift-form')) {
  customElements.define('seal-club-gift-form', SealClubGiftForm);
}
